var _circle, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 36,
    fill: "#DDDEE1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1556_35552)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 46,
    r: 31.5,
    fill: "#EF7D00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1466 56.787C52.5381 57.0629 52.9756 57.2009 53.4591 57.2009C53.9427 57.2009 54.4032 57.0399 54.8637 56.787C55.6466 56.2121 55.969 55.2004 55.6697 54.2806L54.1039 49.4288L58.2256 46.4395C59.0085 45.8646 59.3309 44.8529 59.0315 43.9331C58.7322 43.0133 57.8572 42.3925 56.8901 42.3925H51.7782L50.2124 37.5406C49.9131 36.6209 49.0381 36 48.071 36C47.0809 36 46.2289 36.6209 45.9295 37.5406L44.3637 42.3925H39.2519C38.2618 42.3925 37.4098 43.0133 37.1105 43.9331C36.8111 44.8529 37.1335 45.8646 37.9164 46.4395L42.0381 49.4288L40.4723 54.2806C40.1499 55.2004 40.4953 56.2121 41.2782 56.787C42.0381 57.3389 43.1203 57.3389 43.9032 56.787L48.0249 53.7977L52.1466 56.787ZM48.5781 51.8892C48.4169 51.7742 48.2097 51.7052 48.0255 51.7052C47.8413 51.7052 47.634 51.7742 47.5419 51.9121L42.8676 55.2923C42.7064 55.3843 42.5222 55.3843 42.384 55.2923C42.2459 55.1774 42.1998 54.9934 42.2459 54.8324L44.0189 49.3598C44.134 48.9689 43.9959 48.555 43.6735 48.325L38.9992 44.9448C38.861 44.8528 38.815 44.6689 38.861 44.5079C38.9301 44.347 39.0683 44.232 39.2525 44.232H45.0321C45.4235 44.232 45.7919 43.9561 45.9071 43.5881L47.6801 38.1155C47.7952 37.7935 48.3248 37.7935 48.44 38.1155L50.213 43.5881C50.3281 43.9791 50.6965 44.232 51.088 44.232H56.8676C57.0518 44.232 57.213 44.347 57.259 44.5079C57.3281 44.6689 57.259 44.8528 57.1209 44.9448L52.4465 48.325C52.1242 48.555 51.986 48.9918 52.1011 49.3598L53.8742 54.8324C53.9433 54.9934 53.8742 55.1774 53.736 55.2693C53.5748 55.3613 53.3906 55.3613 53.2525 55.2693L48.5781 51.8892Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1556_35552",
    x: 0.5,
    y: 0.5,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1556_35552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1556_35552",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.dd8df4569f9923aa70b770fa39a3340f.svg";
export { ForwardRef as ReactComponent };